module.exports = __webpack_public_path__ + "img/lock-icon.38120fc5.svg";